<script type="text/ecmascript-6">
    import AxAttributesBase from './AxAttributesBase';

    export default {
        extends: AxAttributesBase,
        props: {
            'product': Object,
        },
        methods: {
            toggleSetFlag: function (level, id) {
                axios.get(this.baseUrl + '/productAttributes/saveSetFlag/' + level + '/' + id).then(function () {
                    this.product.set_flag = this.product.set_flag ? 0 : 1;
                    toastr.success('Set-Flag wurde gespeichert');
                }.bind(this));
            },
        }
    }
</script>

<template>
    <div>
        <h4>Produkt</h4>
        <hr>
        <div class="row p-w-xl">
            <div class="col-md-6">
                <p class="text-muted m-b-md">
                    <button v-if="policies.seeProductTabAttributesSetFlagProduct" type="button" class="btn btn-sm btn-success"
                            :class="product.set_flag ? '' : 'btn-outline'"
                            @click="toggleSetFlag('product', product.id)">
                        <span>Set Artikel</span>
                    </button>
                </p>
                <h5 class="m-b-xs">NOS - Artikel</h5>
                <p class="text-muted m-b-md" v-text="product.nos_flag"></p>
                <h5 class="m-b-xs">Activity</h5>
                <p class="text-muted m-b-md" v-text="product.activity"></p>
                <h5 class="m-b-xs">Artikel-Mehrwertsteuergruppe Verkauf</h5>
                <p class="text-muted m-b-md" v-text="product.tax_class"></p>
                <h5 class="m-b-xs">Artikelart</h5>
                <p class="text-muted m-b-md">Kaufartikel</p>
                <h5 class="m-b-xs">Artikelsperrgutklasse</h5>
                <p class="text-muted m-b-md" v-text="product.cargo_class"></p>
                <h5 class="m-b-xs">Ausverkaufart</h5>
                <p class="text-muted m-b-md" v-text="product.sale ? product.sale.type : '-'"></p>
                <h5 class="m-b-xs">Ausverkaufsdatum</h5>
                <p class="text-muted m-b-md"
                   v-text="product.sale && product.sale.date ? formatDate(product.sale.date) : '-'"></p>
                <h5 class="m-b-xs">Ausverkaufsgrund</h5>
                <p class="text-muted m-b-md" v-text="product.sale ? product.sale.reason : '-'"></p>
                <h5 class="m-b-xs">Einheit Verkauf</h5>
                <p class="text-muted m-b-md">Stück</p>
                <h5 class="m-b-xs">FSC</h5>
                <p class="text-muted m-b-md">0</p>
                <h5 class="m-b-xs">Gesperrt für</h5>
                <p class="text-muted m-b-md">-</p>
            </div>
            <div class="col-md-6">
                <h5 class="m-b-xs">Grundartikelnummer</h5>
                <p class="text-muted m-b-md" v-text="product.basic_article_nr"></p>
                <h5 class="m-b-xs">Herkunftsland</h5>
                <p class="text-muted m-b-md" v-text="product.origin_country"></p>
                <h5 class="m-b-xs">Kollektion</h5>
                <p class="text-muted m-b-md" v-text="product.collection"></p>
                <h5 class="m-b-xs">Kreditor</h5>
                <p class="text-muted m-b-md" v-text="product.creditor"></p>
                <h5 class="m-b-xs">Modellname</h5>
                <p class="text-muted m-b-md" v-text="product.model_name"></p>
                <h5 class="m-b-xs">Produktdimensionsgruppe</h5>
                <p class="text-muted m-b-md" v-text="product.cargo_class"></p>
                <h5 class="m-b-xs">Produktgruppe</h5>
                <p class="text-muted m-b-md" v-text="product.product_group"></p>
                <h5 class="m-b-xs">Produkthauptgruppe</h5>
                <p class="text-muted m-b-md" v-text="product.product_group_main"></p>
                <h5 class="m-b-xs">Produktname</h5>
                <p class="text-muted m-b-md" v-text="product.product_name"></p>
                <h5 class="m-b-xs">Produktnummer</h5>
                <p class="text-muted m-b-md" v-text="product.product_nr"></p>
                <h5 class="m-b-xs">Produkttyp</h5>
                <p class="text-muted m-b-md">Artikel</p>
            </div>
        </div>
    </div>
</template>
